import { Routes, Route, Navigate } from "react-router-dom";
import ResidentLogin from "../pages/Resident/ResidentLogin";
import ResidentforgetPass from "../pages/Resident/Residentforgetpass";
import ResidentLayout from "../components/Resident/ResidentLayout";
import ResidentDashboard from "../pages/Resident/ResidentDashboard";
import ResidentProfile from "../pages/Resident/ResidentProfile";
import { isResidentLoggedIn } from "../helpers/residentauth";
import ResidentBills from "../pages/Resident/ResidentBill";
import ResidentPayments from "../pages/Resident/Residentpaymenthistory";
import QuickPay from "../pages/Quickpay/quickpay";
import Tenants from "../pages/Resident/Tenants"
// Protected route wrapper
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    return isResidentLoggedIn() ? <>{children}</> : <Navigate to="/resident/login" replace />;
};

const ResidentRoutes = () => {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<ResidentLogin />} />
            <Route path="/resident/login" element={<ResidentLogin />} />
            <Route path="/quick-pay-bill" element={<QuickPay/>}/>
            <Route path="/resident/forgetpassword" element={<ResidentforgetPass />} />

            {/* Protected Routes */}
            <Route path="/resident" element={
                <ProtectedRoute>
                    <ResidentLayout />
                </ProtectedRoute>
            }>
                <Route path="dashboard" element={<ResidentDashboard />} />
                <Route path="profile" element={<ResidentProfile />} />
                <Route path="bills" element={<ResidentBills />}/>
                <Route path="payments" element={<ResidentPayments/>} />
                <Route path="tenants" element={<Tenants/>}/>
            </Route>
             {/* <Route path="dashboard" element={<ResidentDashboard />} />
                <Route path="profile" element={<ResidentProfile />} /> */}

        </Routes>
    );
};

export default ResidentRoutes;